import type { ImageOptions } from '@xing-com/crate-common-graphql-types';

// Keep requested variants aligned with the edit cropper and view-mode expansion.
export const HEADER_IMAGE_ASPECT_RATIO = 2;

const getHeaderImageHeight = (width: number): number =>
  width / HEADER_IMAGE_ASPECT_RATIO;

export const HEADER_IMAGE_OPTIONS: ImageOptions[] = [
  {
    height: getHeaderImageHeight(740),
    reference: 'handheld',
    width: 740,
  },
  {
    height: getHeaderImageHeight(1480),
    reference: 'handheld_2x',
    width: 1480,
  },
  {
    height: getHeaderImageHeight(2220),
    reference: 'handheld_3x',
    width: 2220,
  },
  {
    height: getHeaderImageHeight(644),
    reference: 'tablet',
    width: 644,
  },
  {
    height: getHeaderImageHeight(1288),
    reference: 'tablet_2x',
    width: 1288,
  },
  {
    height: getHeaderImageHeight(1932),
    reference: 'tablet_3x',
    width: 1932,
  },
  {
    height: getHeaderImageHeight(1312),
    reference: 'desktop',
    width: 1312,
  },
  {
    height: getHeaderImageHeight(2624),
    reference: 'desktop_2x',
    width: 2624,
  },
  {
    height: getHeaderImageHeight(3840),
    reference: 'desktop_3x',
    width: 3840,
  },
];
